import { addAccessibility } from '.';
import { addEventHandlers } from '.';

const applyProps = (props) => {
  return {
    ...addAccessibility(props),
    ...addEventHandlers(props),
  };
};

export default applyProps;
